import { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { Route, Routes } from "react-router-dom";
import { TailSpin } from "react-loader-spinner";
import MyNavbar from "../Navbar/MyNavbar";
import AuthPage from "../../pages/AuthPage";
import Webinars from "../../pages/Webinars";
import InfoWebinar from "../../pages/InfoWebinar";
import Login from "../../pages/Login";
import { ILoader } from "../../App";
import { checkAuth, logout } from "../../services/Session";
import "./admin.css";

interface Props {
    handleLoader: ILoader;
}

export default function AdminLayout({ handleLoader }: Props) {
    const [isLogged, setIsLogged] = useState<boolean | null>(null);

    useEffect(() => {
        checkAuth().then(setIsLogged);
    }, []);

    const onLogout = async () => {
        await logout();
        setIsLogged(false);
    };

    if (isLogged === null) {
        return (
            <div className="admin-shell">
                <div className="admin-status">
                    <TailSpin color="#0041B9" height={48} width={48} />
                </div>
            </div>
        );
    }

    return (
        <div className="admin-shell">
            <MyNavbar isLogged={isLogged} onLogout={onLogout} />
            <Container className="py-4 py-md-5">
                {isLogged ? (
                    <Routes>
                        {/* <Route path="" element={<MainForm handleLoader={handleLoader} />} /> */}
                        <Route path="authcode" element={<AuthPage handleLoader={handleLoader} />} />
                        <Route path="list" element={<Webinars handleLoader={handleLoader} />} />
                        <Route path="webinar/:id" element={<InfoWebinar handleLoader={handleLoader} />} />
                        <Route path="*" element={<Webinars handleLoader={handleLoader} />} />
                    </Routes>
                ) : (
                    <Routes>
                        <Route path="*" element={<Login onSuccess={() => setIsLogged(true)} />} />
                    </Routes>
                )}
            </Container>
        </div>
    );
}
